// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".divider[data-v-5b06183e] {\n  margin: calc(var(--magic-space, 16px) + var(--magic-space--small, 8px)) auto;\n  border-color: rgba(var(--magic-dark, #000), 0.25);\n}", ""]);
// Exports
module.exports = exports;
